import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface ToneOptionCSSStyle extends UIComponentCSSStyle
{   
    getCardListDivCSSStyle():object;
}

export class ToneOptionCSSStyleImpl extends UIComponentCSSStyleImpl implements ToneOptionCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
            width:'100%',
            // height:'85px',
            justifyContent:'center',
            display:'flex',
            flexFlow: "row wrap"
        };
    }
  
    getCardListDivCSSStyle():object
    {
        return{
            marginRight: "21px",
            marginLeft: "21px",
            marginTop: "10px",
            justifyContent:'center',
            display:'inline-block',
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/toneoption/toneoptioncss.tsx